import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable()
export class AdministracionGarantiaService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'neoParametrizacionCondicionIntermediario';
  }

  getCondicionIF(idCliente): Observable<any> {
    return this._http.get(this.url + '/parametrizacionCondicionIF/' + idCliente).pipe(catchError(HandleHttpError));
  }

  saveCondicionIF(condicionIntermediarioDTO): Observable<any> {
    let body = JSON.stringify(condicionIntermediarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/crear', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  updateCondicionIF(condicionIntermediarioDTO): Observable<any> {
    let body = JSON.stringify(condicionIntermediarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/modificar', body, { headers: headers }).pipe(catchError(HandleHttpError));
  }

  deleteCondicionIF(condicionIntermediarioDTO): Observable<any> {
    let body = JSON.stringify(condicionIntermediarioDTO);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/eliminar' , body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }
}
